import { SyncStorageKey, syncStorage } from 'utils/environment/sync-storage';

export const resetLastTimeStoreUpdated: (currentTime?: number) => void = currentTime =>
  syncStorage.setNumber(SyncStorageKey.LAST_TIME_STORE_UPDATED, currentTime || Date.now());
